export const EDITABLE_CELL = 'editable-cell';
export const EDITABLE_HEADER = 'editable-cell-header';

export const PILL_STYLES_BY_INDEX: Record<number, string[]> = {
  0: ['bg-aux-gray-dark-100', 'text-white'],
  1: ['border-[0.5px]', 'border-aux-green-dark', 'bg-white', 'text-aux-green-dark'],
  2: ['border-[0.5px]', 'border-aux-gray-darkest', 'bg-aux-gray-dark', 'text-aux-gray-darkest'],
  3: ['bg-aux-gray-darkest', 'text-white'],
  4: ['bg-aux-green-dark', 'text-white'],
  5: ['border-[0.5px]', 'border-aux-blue', 'bg-white', 'text-aux-blue'],
};
